import { h, Component } from 'preact';
import { route } from 'preact-router';
import PFeed from '../../../services/prematch-feed';
import Page from '../../../services/page-data-feed';
import * as P from '../desktop-templates/prematch-tournament.jsx';
import { RegionFlagIcon, TournamentFlagIcon } from '../desktop-templates/prematch-menu.jsx';
import Ticket from "../utils/ticket-logic.jsx"
import { StatsIconRegular } from '../utils/icons.jsx';
import {
	TodayWidget as AwrabetTodayWidget,
	TournamentDisplay as AwrabetTournamentDisplay,
	Pagination as AwrabetPagination,
	DailyEventDisplay as AwrabetDailyEventDisplay,
} from '../../awrabet/desktop-components/today-widget.jsx';

export class TodayWidget extends AwrabetTodayWidget {

	render({sport}) {
		const { tournaments, currentPage } = this.state;
		const tournamentsPerPage = 5;
		const totalPages = Math.ceil(tournaments.length / tournamentsPerPage);
		const displayedTournaments = tournaments.slice((currentPage - 1) * tournamentsPerPage, currentPage * tournamentsPerPage);

		return (
			<div>
				<div class="bg-slate-100">
					{displayedTournaments.map(tournament => (
						<TournamentDisplay tournament={tournament} key={tournament.id} />
					))}
				</div>
				<Pagination totalPages={totalPages} currentPage={currentPage} onPageChange={this.handlePageChange} />
			</div>
		);
	}
}

// New component for displaying tournament
export class TournamentDisplay extends AwrabetTournamentDisplay {
	render() {
		const { tournament } = this.props;
		return (
			<div class="pb-0.5 bg-harif-800">
				<div class="flex items-center py-1 gap-1 border-b border-b-harif-950">
					<div class="pl-2">
						<div class="h-4 w-6 flex items-center justify-center">
							<RegionFlagIcon
								category={PFeed.getWithParents(tournament.parent).category}
							/>
						</div>
					</div>
					<P.CardHeaderTitle>{PFeed.getWithParents(tournament.parent).category.name} - {tournament.name}</P.CardHeaderTitle>
				</div>
				<DailyEventDisplay tournament={tournament} />
			</div>
		);
	}
}

export class Pagination extends AwrabetPagination {
	render() {
		const { totalPages, currentPage, onPageChange } = this.props;
		const maxButtons = 7;
		const buttons = [];

		if (totalPages <= maxButtons) {
			for (let i = 1; i <= totalPages; i++) {
				buttons.push(i);
			}
		} else {
			buttons.push(1);
			let start = Math.max(2, currentPage - 2);
			let end = Math.min(totalPages - 1, currentPage + 2);

			if (currentPage <= 3) {
				end = 5;
			} else if (currentPage >= totalPages - 2) {
				start = totalPages - 4;
			}

			for (let i = start; i <= end; i++) {
				buttons.push(i);
			}

			buttons.push(totalPages);
		}

		return (
			<div class="pagination flex justify-center pt-4 pb-4">
				{buttons.map(page => (
					<button
						class={`px-3 py-1 mx-1 rounded ${
							page === currentPage
								? 'bg-custom-orange text-white'
								: 'bg-harif-900 text-white hover:bg-harifzinc-800'
						}`}
						onClick={() => onPageChange(page)}
					>
						{page}
					</button>
				))}
			</div>
		);
	}
}

export class DailyEventDisplay extends AwrabetDailyEventDisplay {

	render() {
		const { tournamentData } = this.state;
		if (!tournamentData) return <div></div>;

		const today = new Date();
		const endOfDay = new Date(today.setHours(23, 59, 59, 999)).getTime() / 1000;
		const eventsToday = Object.values(tournamentData.sub).filter(event => event.date <= endOfDay);

		const { sport, category, tournament } = PFeed.getWithParents(this.props.tournament.id);
		const displayRuleFiltered = tournamentData.displayRule;

		return (
			<div>
				<P.OddsTableHeadRow>
					<P.HeadRowCellId>Stats</P.HeadRowCellId>
					<P.HeadRowCellId>ID</P.HeadRowCellId>
					<P.HeadRowCellTime>Time</P.HeadRowCellTime>
					<P.HeadRowCellEvent>Event</P.HeadRowCellEvent>
					<P.OddsWidthContainerLarge>
						{displayRuleFiltered.map(outcome => <P.HeadOddCell>{outcome.name}</P.HeadOddCell>)}
						<P.HeadMoreCell />
					</P.OddsWidthContainerLarge>
				</P.OddsTableHeadRow>
				{eventsToday.map(event => (
					<P.EventRow>
						<P.HeadRowCellId onClick={e => Page.openEventStats(event)}><StatsIconRegular class="h-4" /></P.HeadRowCellId>
						<P.HeadRowCellId>{event.short}</P.HeadRowCellId>
						<P.HeadRowCellTime>{new Date(event.date * 1000).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' })}</P.HeadRowCellTime>
						<P.ContentRowCellEvent><a href="javascript:void(0);" class="cursor-pointer hover:underline" onClick={e => route(`/prematch/${sport.id.split('/').pop()}/${category.id.split('/').pop()}/${tournament.id.split('/').pop()}/${event.id.split('/').pop()}`)}>{event.home}{event.away != null ? ' - ' + event.away : ''}</a></P.ContentRowCellEvent>
						<P.OddsWidthContainerLarge>
							{displayRuleFiltered.map(outcome => {
								const [marketCode, outcomeCode] = outcome.id.split('.');
								const market = event.sub[`/market/${event.id.split('/').slice(-1)[0]}/${marketCode}`] || { sub: {}, id: '' };
								const odd = market.sub[market.id.replace('market', 'odd') + '/' + outcomeCode] || { value: 0, active: false };
								return <P.EventOddButton
									value={odd.value}
									active={odd.active}
									onClick={() => Ticket.togglePrematchOdds(odd.id)}
									selected={Ticket.hasPrematchOdds(odd.id)} />;
							})}
							<P.MoreButton onClick={e => route(`/prematch/${sport.id.split('/').pop()}/${category.id.split('/').pop()}/${tournament.id.split('/').pop()}/${event.id.split('/').pop()}`)}>+</P.MoreButton>
						</P.OddsWidthContainerLarge>
					</P.EventRow>
				))}
			</div>
		);
	}
}
